<template>
    <div class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
        @mouseenter="$sidebar.onMouseEnter()"
        @mouseleave="$sidebar.onMouseLeave()">
        <div class="scrollbar-inner" ref="sidebarScrollArea">
        <div class="sidenav-header d-flex align-items-center">
            <a class="navbar-brand" href="#">
                <!--
                <img :src="logo" class="navbar-brand-img" alt="Sidebar logo">
                -->
                <router-link :to="{ name: 'home'}" tag="h2" class="title text-info mb-0" :class="themeClass">
                SOCRATES
                </router-link>
            </a>
            <div class="ml-auto">
            <!-- Sidenav toggler -->
            <div class="sidenav-toggler d-none d-xl-block"
                :class="{'active': !$sidebar.isMinimized }"
                @click="minimizeSidebar">
                <div class="sidenav-toggler-inner" id="sidenav-toggler">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                </div>
            </div>
            </div>
        </div>
        <slot></slot>
        <div class="navbar-inner">
            <ul class="navbar-nav">
            <slot name="links">
                <sidebar-item
                v-for="(link, index) in sidebarLinks"
                :key="link.name + index"
                :link="link"
                >
                <sidebar-item
                    v-for="(subLink, index) in link.children"
                    :key="subLink.name + index"
                    :link="subLink"
                >
                </sidebar-item>
                </sidebar-item>
            </slot>
            </ul>
            <slot name="links-after"></slot>
        </div>
        </div>
    </div>
</template>

<script>
    export default {
    name: 'sidebar',
        props: {
            logo: {
                type: String,
                default: 'https://demos.creative-tim.com/vue-argon-dashboard-pro/img/brand/green.png',
                description: 'Sidebar app logo'
            },
            sidebarLinks: {
                type: Array,
                default: () => [],
                description:
                    "List of sidebar links as an array if you don't want to use components for these."
            },
            autoClose: {
                type: Boolean,
                default: true,
                description:
                    'Whether sidebar should autoclose on mobile when clicking an item'
            }
        },

        provide() {
            return {
                autoClose: this.autoClose
            };
        },

        mounted() {
            this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth
            this.minimizeSidebar()
        },
        
        computed: {
            themeClass() {
                return 'text-socrates-' + window.socratesTheme
            }
        },

        methods: {
            minimizeSidebar() {
                if (this.$sidebar) {
                    this.$sidebar.toggleMinimize();
                }
            }
        },

        beforeDestroy() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.showSidebar = false;
            }
        }
    };
</script>
